import { RadioButton } from '@factorialco/deprecated-design-system'
import { useField } from 'formik'
import { UniversalExportsEntitiesConfigurationFormatEnum } from 'generated/resources/datatable.graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

const ExportFormat = () => {
  const [field, {}, { setValue }] =
    useField<UniversalExportsEntitiesConfigurationFormatEnum>('format')

  useUnsafeEffect(() => {
    setValue('xlsx')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <RadioButton
        checked={field.value === 'xlsx'}
        value={'xlsx'}
        onChange={() => setValue('xlsx')}
        label={i18n.t('universal_exports.export_format.format_types.xlsx')}
        size="small"
      />
      <RadioButton
        checked={field.value === 'csv'}
        value={'csv'}
        onChange={() => setValue('csv')}
        label={i18n.t('universal_exports.export_format.format_types.csv')}
        size="small"
      />
    </>
  )
}

export default ExportFormat
